import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderFileFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.6241 6.54078C15.9283 5.92578 14.9583 5.60995 13.6616 5.60995H11.4508C11.3091 5.60995 11.1666 5.58745 11.0291 5.54245C10.6866 5.42995 10.3974 5.11578 10.2558 4.70245L9.86659 3.56412C9.84075 3.48745 9.79992 3.41995 9.76659 3.34745H12.9241C15.1449 3.34745 16.4324 4.48412 16.6241 6.54078ZM17.9133 10.7124L17.9166 10.3057C17.9166 10.2849 17.9133 10.2691 17.9133 10.2482V7.07745C17.9133 4.00578 16.0016 2.09745 12.9241 2.09745H7.92575C7.91242 2.09745 7.89825 2.09412 7.88492 2.09412H6.32242C3.46992 2.09412 2.08325 3.68328 2.08325 6.95162V13.0449C2.08325 16.0883 3.90325 17.9058 6.95242 17.9058H13.0341C16.0241 17.9058 17.8199 16.1449 17.8824 13.1999C17.8949 13.1507 17.9133 13.1024 17.9133 13.0491V10.7124Z",
		fill: "currentColor"
	})
});
export default SvgFolderFileFill;
